'use client'

import type { StoreFrontDto } from '@b-stock/listing-api-client'

import type { CmsSellerProfile } from '@/helpers/api/fetchPayload'

import StorefrontTabs from './StorefrontTabs'
import { useSellerProfileLivePreview } from './useSellerProfileLivePreview'

/**
 * The storefront tabs inside cms-portal's Live Preview pane.
 *
 * Every edit in the admin form arrives as a whole profile object, so all five CMS tabs re-render as
 * the editor types. The tab the editor is on is kept by `useTabsUrlParams` in `StorefrontTabs`,
 * and the entry link's `?tab=` lands them on it.
 */
export default function StorefrontLivePreview({
  storefront,
  profile,
  serverURL,
  showBadge = false,
}: {
  storefront: StoreFrontDto
  profile: CmsSellerProfile
  serverURL: string
  showBadge?: boolean
}) {
  const data = useSellerProfileLivePreview(profile, serverURL)
  return (
    <StorefrontTabs
      storefront={storefront}
      cmsSellerProfile={data}
      showBadge={showBadge}
    />
  )
}
